import React from 'react';
import {useHistory} from 'react-router-dom';

interface IosPushNotifierProps {
}

const IosPushHandler: React.FC<IosPushNotifierProps> = () => {
  const history = useHistory();

  // @ts-ignore
  window.handlePushNotification = function (data: any) {
    console.log('Push notification received:', data);
    alert(JSON.stringify(data));
    if(data == 'payment'){
      history.push('/payment');
    }
  }
  return null;
};

export default IosPushHandler;
